import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/services/admin.service';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-add-module',
  templateUrl: './add-module.component.html',
  styleUrls: ['./add-module.component.scss']
})
export class AddModuleComponent implements OnInit {
  moduleForm!: FormGroup;
  loader: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adminservice: AdminService,
    private dialogRef: MatDialogRef<AddModuleComponent>
  ) { }

  ngOnInit() {
    this.formBuilder();
    if (this.data.courseId > 0) {
      const data = {
        moduleId: this.data.module.id,
        title: this.data.module.titulo,
      }
      this.moduleForm.patchValue(data);
    }
  }

  formBuilder(){
    this.moduleForm = new FormGroup({
      moduleId: new FormControl(''),
      title: new FormControl('', Validators.required)
    })
  }

  saveDataModule(){
    if (!this.moduleForm.valid) {
      return
    }

    const request = {
      curso_id: this.data.courseId,
      modulo_id: this.moduleForm.value.moduleId,
      titulo: this.moduleForm.value.title
    }
    this.loader = true;
    this.adminservice.saveModule(request).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          this.dialogRef.close(true);
        }
      }
    );
  }

}
